export default[
    {
        "name": "ios-add",
        "tag": "add,include,invite,plus"
    },
    {
        "name": "md-add",
        "tag": "add,include,invite,plus"
    },
    {
        "name": "ios-add-circle",
        "tag": "add,circle"
    },
    {
        "name": "ios-add-circle-outline",
        "tag": "add,circle"
    },
    {
        "name": "md-add-circle",
        "tag": "add,circle"
    },
    {
        "name": "ios-alarm",
        "tag": "alarm"
    },
    {
        "name": "ios-alarm-outline",
        "tag": "alarm"
    },
    {
        "name": "md-alarm",
        "tag": "alarm"
    },
    {
        "name": "ios-albums",
        "tag": "albums,boxes,slides,square"
    },
    {
        "name": "ios-albums-outline",
        "tag": "albums,boxes,slides,square"
    },
    {
        "name": "md-albums",
        "tag": "albums,boxes,slides,square"
    },
    {
        "name": "ios-alert",
        "tag": "!,alert,attention,exclamation,notice,warning"
    },
    {
        "name": "ios-alert-outline",
        "tag": "!,alert,attention,exclamation,notice,warning"
    },
    {
        "name": "md-alert",
        "tag": "!,alert,attention,exclamation,notice,warning"
    },
    {
        "name": "ios-american-football",
        "tag": "american,football"
    },
    {
        "name": "ios-american-football-outline",
        "tag": "american,football"
    },
    {
        "name": "md-american-football",
        "tag": "american,football"
    },
    {
        "name": "ios-analytics",
        "tag": "analytics,data,metrics,track"
    },
    {
        "name": "ios-analytics-outline",
        "tag": "analytics,data,metrics,track"
    },
    {
        "name": "md-analytics",
        "tag": "analytics,data,metrics,track"
    },
    {
        "name": "logo-android",
        "tag": "android,google,mobile,logo"
    },
    {
        "name": "logo-angular",
        "tag": "angular,logo"
    },
    {
        "name": "ios-aperture",
        "tag": "aperture,dark,images,levels,light,settings"
    },
    {
        "name": "ios-aperture-outline",
        "tag": "aperture,dark,images,levels,light,settings"
    },
    {
        "name": "md-aperture",
        "tag": "aperture,dark,images,levels,light,settings"
    },
    {
        "name": "logo-apple",
        "tag": "apple,mac,mobile,logo"
    },
    {
        "name": "ios-apps",
        "tag": "apps,applications"
    },
    {
        "name": "ios-apps-outline",
        "tag": "apps,applications"
    },
    {
        "name": "md-apps",
        "tag": "apps,applications"
    },
    {
        "name": "ios-appstore",
        "tag": "appstore,store"
    },
    {
        "name": "ios-appstore-outline",
        "tag": "appstore,store"
    },
    {
        "name": "md-appstore",
        "tag": "appstore,store"
    },
    {
        "name": "ios-archive",
        "tag": "archive,email"
    },
    {
        "name": "ios-archive-outline",
        "tag": "archive,email"
    },
    {
        "name": "md-archive",
        "tag": "archive,email"
    },
    {
        "name": "ios-arrow-back",
        "tag": "arrow,back,chevron,navigation"
    },
    {
        "name": "md-arrow-back",
        "tag": "arrow,back,chevron,navigation"
    },
    {
        "name": "ios-arrow-down",
        "tag": "arrow,chevron,down"
    },
    {
        "name": "md-arrow-down",
        "tag": "arrow,chevron,down"
    },
    {
        "name": "ios-arrow-dropdown",
        "tag": "arrow,dropdown"
    },
    {
        "name": "md-arrow-dropdown",
        "tag": "arrow,dropdown"
    },
    {
        "name": "ios-arrow-dropdown-circle",
        "tag": "arrow,circle,dropdown"
    },
    {
        "name": "md-arrow-dropdown-circle",
        "tag": "arrow,circle,dropdown"
    },
    {
        "name": "ios-arrow-dropleft",
        "tag": "arrow,dropleft"
    },
    {
        "name": "md-arrow-dropleft",
        "tag": "arrow,dropleft"
    },
    {
        "name": "ios-arrow-dropleft-circle",
        "tag": "arrow,circle,dropleft"
    },
    {
        "name": "md-arrow-dropleft-circle",
        "tag": "arrow,circle,dropleft"
    },
    {
        "name": "ios-arrow-dropright",
        "tag": "arrow,dropright"
    },
    {
        "name": "md-arrow-dropright",
        "tag": "arrow,dropright"
    },
    {
        "name": "ios-arrow-dropright-circle",
        "tag": "arrow,circle,dropright"
    },
    {
        "name": "md-arrow-dropright-circle",
        "tag": "arrow,circle,dropright"
    },
    {
        "name": "ios-arrow-dropup",
        "tag": "arrow,dropup"
    },
    {
        "name": "md-arrow-dropup",
        "tag": "arrow,dropup"
    },
    {
        "name": "ios-arrow-dropup-circle",
        "tag": "arrow,circle,dropup"
    },
    {
        "name": "md-arrow-dropup-circle",
        "tag": "arrow,circle,dropup"
    },
    {
        "name": "ios-arrow-forward",
        "tag": "arrow,chevron,forward,navigation"
    },
    {
        "name": "md-arrow-forward",
        "tag": "arrow,chevron,forward,navigation"
    },
    {
        "name": "ios-arrow-round-back",
        "tag": "arrow,back,round"
    },
    {
        "name": "md-arrow-round-back",
        "tag": "arrow,back,round"
    },
    {
        "name": "ios-arrow-round-down",
        "tag": "arrow,down,round"
    },
    {
        "name": "md-arrow-round-down",
        "tag": "arrow,down,round"
    },
    {
        "name": "ios-arrow-round-forward",
        "tag": "arrow,forward,round"
    },
    {
        "name": "md-arrow-round-forward",
        "tag": "arrow,forward,round"
    },
    {
        "name": "ios-arrow-round-up",
        "tag": "arrow,round,up"
    },
    {
        "name": "md-arrow-round-up",
        "tag": "arrow,round,up"
    },
    {
        "name": "ios-arrow-up",
        "tag": "arrow,chevron,up"
    },
    {
        "name": "md-arrow-up",
        "tag": "arrow,chevron,up"
    },
    {
        "name": "ios-at",
        "tag": "@,at"
    },
    {
        "name": "ios-at-outline",
        "tag": "@,at"
    },
    {
        "name": "md-at",
        "tag": "@,at"
    },
    {
        "name": "ios-attach",
        "tag": "attach"
    },
    {
        "name": "md-attach",
        "tag": "attach"
    },
    {
        "name": "ios-backspace",
        "tag": "backspace"
    },
    {
        "name": "ios-backspace-outline",
        "tag": "backspace"
    },
    {
        "name": "md-backspace",
        "tag": "backspace"
    },
    {
        "name": "ios-barcode",
        "tag": "barcode,camera,reader"
    },
    {
        "name": "ios-barcode-outline",
        "tag": "barcode,camera,reader"
    },
    {
        "name": "md-barcode",
        "tag": "barcode,camera,reader"
    },
    {
        "name": "ios-baseball",
        "tag": "baseball"
    },
    {
        "name": "ios-baseball-outline",
        "tag": "baseball"
    },
    {
        "name": "md-baseball",
        "tag": "baseball"
    },
    {
        "name": "ios-basket",
        "tag": "basket"
    },
    {
        "name": "ios-basket-outline",
        "tag": "basket"
    },
    {
        "name": "md-basket",
        "tag": "basket"
    },
    {
        "name": "ios-basketball",
        "tag": "basketball"
    },
    {
        "name": "ios-basketball-outline",
        "tag": "basketball"
    },
    {
        "name": "md-basketball",
        "tag": "basketball"
    },
    {
        "name": "ios-battery-charging",
        "tag": "battery,charging"
    },
    {
        "name": "md-battery-charging",
        "tag": "battery,charging"
    },
    {
        "name": "ios-battery-dead",
        "tag": "battery,dead"
    },
    {
        "name": "md-battery-dead",
        "tag": "battery,dead"
    },
    {
        "name": "ios-battery-full",
        "tag": "battery,full"
    },
    {
        "name": "md-battery-full",
        "tag": "battery,full"
    },
    {
        "name": "ios-beaker",
        "tag": "beaker,flask,mixture,potion"
    },
    {
        "name": "ios-beaker-outline",
        "tag": "beaker,flask,mixture,potion"
    },
    {
        "name": "md-beaker",
        "tag": "beaker,flask,mixture,potion"
    },
    {
        "name": "ios-beer",
        "tag": "beer,drink,eat,food"
    },
    {
        "name": "ios-beer-outline",
        "tag": "beer,drink,eat,food"
    },
    {
        "name": "md-beer",
        "tag": "beer,drink,eat,food"
    },
    {
        "name": "ios-bicycle",
        "tag": "bicycle"
    },
    {
        "name": "md-bicycle",
        "tag": "bicycle"
    },
    {
        "name": "logo-bitcoin",
        "tag": "bitcoin,currency,money,logo,trade"
    },
    {
        "name": "ios-bluetooth",
        "tag": "bluetooth,cloud,connection"
    },
    {
        "name": "md-bluetooth",
        "tag": "bluetooth,cloud,connection"
    },
    {
        "name": "ios-boat",
        "tag": "boat"
    },
    {
        "name": "ios-boat-outline",
        "tag": "boat"
    },
    {
        "name": "md-boat",
        "tag": "boat"
    },
    {
        "name": "ios-body",
        "tag": "body"
    },
    {
        "name": "ios-body-outline",
        "tag": "body"
    },
    {
        "name": "md-body",
        "tag": "body"
    },
    {
        "name": "ios-bonfire",
        "tag": "bonfire,heat,hot"
    },
    {
        "name": "ios-bonfire-outline",
        "tag": "bonfire,heat,hot"
    },
    {
        "name": "md-bonfire",
        "tag": "bonfire,heat,hot"
    },
    {
        "name": "ios-book",
        "tag": "book,read"
    },
    {
        "name": "ios-book-outline",
        "tag": "book,read"
    },
    {
        "name": "md-book",
        "tag": "book,read"
    },
    {
        "name": "ios-bookmark",
        "tag": "bookmark,favorite,save,tag"
    },
    {
        "name": "ios-bookmark-outline",
        "tag": "bookmark,favorite,save,tag"
    },
    {
        "name": "md-bookmark",
        "tag": "bookmark,favorite,save,tag"
    },
    {
        "name": "ios-bookmarks",
        "tag": "bookmarks,favorite"
    },
    {
        "name": "ios-bookmarks-outline",
        "tag": "bookmarks,favorite"
    },
    {
        "name": "md-bookmarks",
        "tag": "bookmarks,favorite"
    },
    {
        "name": "ios-bowtie",
        "tag": "bowtie"
    },
    {
        "name": "ios-bowtie-outline",
        "tag": "bowtie"
    },
    {
        "name": "md-bowtie",
        "tag": "bowtie"
    },
    {
        "name": "ios-briefcase",
        "tag": "briefcase,folder,organize"
    },
    {
        "name": "ios-briefcase-outline",
        "tag": "briefcase,folder,organize"
    },
    {
        "name": "md-briefcase",
        "tag": "briefcase,folder,organize"
    },
    {
        "name": "ios-browsers",
        "tag": "browsers,square"
    },
    {
        "name": "ios-browsers-outline",
        "tag": "browsers,square"
    },
    {
        "name": "md-browsers",
        "tag": "browsers,square"
    },
    {
        "name": "ios-brush",
        "tag": "brush"
    },
    {
        "name": "ios-brush-outline",
        "tag": "brush"
    },
    {
        "name": "md-brush",
        "tag": "brush"
    },
    {
        "name": "logo-buffer",
        "tag": "buffer,share,logo"
    },
    {
        "name": "ios-bug",
        "tag": "bug,develop,error,hacker,program"
    },
    {
        "name": "ios-bug-outline",
        "tag": "bug,develop,error,hacker,program"
    },
    {
        "name": "md-bug",
        "tag": "bug,develop,error,hacker,program"
    },
    {
        "name": "ios-build",
        "tag": "build"
    },
    {
        "name": "ios-build-outline",
        "tag": "build"
    },
    {
        "name": "md-build",
        "tag": "build"
    },
    {
        "name": "ios-bulb",
        "tag": "bulb"
    },
    {
        "name": "ios-bulb-outline",
        "tag": "bulb"
    },
    {
        "name": "md-bulb",
        "tag": "bulb"
    },
    {
        "name": "ios-bus",
        "tag": "bus"
    },
    {
        "name": "ios-bus-outline",
        "tag": "bus"
    },
    {
        "name": "md-bus",
        "tag": "bus"
    },
    {
        "name": "ios-cafe",
        "tag": "cafe"
    },
    {
        "name": "ios-cafe-outline",
        "tag": "cafe"
    },
    {
        "name": "md-cafe",
        "tag": "cafe"
    },
    {
        "name": "ios-calculator",
        "tag": "arithmatic,calculator,math"
    },
    {
        "name": "ios-calculator-outline",
        "tag": "arithmatic,calculator,math"
    },
    {
        "name": "md-calculator",
        "tag": "arithmatic,calculator,math"
    },
    {
        "name": "ios-calendar",
        "tag": "calendar,date,month,week"
    },
    {
        "name": "ios-calendar-outline",
        "tag": "calendar,date,month,week"
    },
    {
        "name": "md-calendar",
        "tag": "calendar,date,month,week"
    },
    {
        "name": "ios-call",
        "tag": "call,telephone"
    },
    {
        "name": "ios-call-outline",
        "tag": "call,telephone"
    },
    {
        "name": "md-call",
        "tag": "call,telephone"
    },
    {
        "name": "ios-camera",
        "tag": "camera,image,photo"
    },
    {
        "name": "ios-camera-outline",
        "tag": "camera,image,photo"
    },
    {
        "name": "md-camera",
        "tag": "camera,image,photo"
    },
    {
        "name": "ios-car",
        "tag": "car"
    },
    {
        "name": "ios-car-outline",
        "tag": "car"
    },
    {
        "name": "md-car",
        "tag": "car"
    },
    {
        "name": "ios-card",
        "tag": "$,card,cash,credit,debit,dollars,money,price,shopping"
    },
    {
        "name": "ios-card-outline",
        "tag": "$,card,cash,credit,debit,dollars,money,price,shopping"
    },
    {
        "name": "md-card",
        "tag": "$,card,cash,credit,debit,dollars,money,price,shopping"
    },
    {
        "name": "ios-cart",
        "tag": "cart"
    },
    {
        "name": "ios-cart-outline",
        "tag": "cart"
    },
    {
        "name": "md-cart",
        "tag": "cart"
    },
    {
        "name": "ios-cash",
        "tag": "$,cash,credit,debit,dollars,money,price,shopping"
    },
    {
        "name": "ios-cash-outline",
        "tag": "$,cash,credit,debit,dollars,money,price,shopping"
    },
    {
        "name": "md-cash",
        "tag": "$,cash,credit,debit,dollars,money,price,shopping"
    },
    {
        "name": "ios-chatboxes",
        "tag": "chatboxes,talk"
    },
    {
        "name": "ios-chatboxes-outline",
        "tag": "chatboxes,talk"
    },
    {
        "name": "md-chatboxes",
        "tag": "chatboxes,talk"
    },
    {
        "name": "ios-chatbubbles",
        "tag": "chatbubbles,talk"
    },
    {
        "name": "ios-chatbubbles-outline",
        "tag": "chatbubbles,talk"
    },
    {
        "name": "md-chatbubbles",
        "tag": "chatbubbles,talk"
    },
    {
        "name": "ios-checkbox",
        "tag": "checkbox"
    },
    {
        "name": "ios-checkbox-outline",
        "tag": "checkbox,outline"
    },
    {
        "name": "md-checkbox",
        "tag": "checkbox"
    },
    {
        "name": "md-checkbox-outline",
        "tag": "checkbox,outline"
    },
    {
        "name": "ios-checkmark",
        "tag": "checkmark,success,ok"
    },
    {
        "name": "md-checkmark",
        "tag": "checkmark,success,ok"
    },
    {
        "name": "ios-checkmark-circle",
        "tag": "checkmark,circle,success,ok"
    },
    {
        "name": "ios-checkmark-circle-outline",
        "tag": "checkmark,circle,outline,success,ok"
    },
    {
        "name": "md-checkmark-circle",
        "tag": "checkmark,circle,success,ok"
    },
    {
        "name": "md-checkmark-circle-outline",
        "tag": "checkmark,circle,outline,success,ok"
    },
    {
        "name": "logo-chrome",
        "tag": "chrome,logo"
    },
    {
        "name": "ios-clipboard",
        "tag": "clipboard,write"
    },
    {
        "name": "ios-clipboard-outline",
        "tag": "clipboard,write"
    },
    {
        "name": "md-clipboard",
        "tag": "clipboard,write"
    },
    {
        "name": "ios-clock",
        "tag": "clock,time"
    },
    {
        "name": "ios-clock-outline",
        "tag": "clock,time"
    },
    {
        "name": "md-clock",
        "tag": "clock,time"
    },
    {
        "name": "ios-close",
        "tag": "close,delete,remove"
    },
    {
        "name": "md-close",
        "tag": "close,delete,remove"
    },
    {
        "name": "ios-close-circle",
        "tag": "circle,close"
    },
    {
        "name": "ios-close-circle-outline",
        "tag": "circle,close"
    },
    {
        "name": "md-close-circle",
        "tag": "circle,close"
    },
    {
        "name": "ios-closed-captioning",
        "tag": "captioning,closed,film,movie,television"
    },
    {
        "name": "ios-closed-captioning-outline",
        "tag": "captioning,closed,film,movie,television"
    },
    {
        "name": "md-closed-captioning",
        "tag": "captioning,closed,film,movie,television"
    },
    {
        "name": "ios-cloud",
        "tag": "cloud,storage,weather,whether"
    },
    {
        "name": "ios-cloud-outline",
        "tag": "cloud,storage,weather,whether"
    },
    {
        "name": "md-cloud",
        "tag": "cloud,storage,weather,whether"
    },
    {
        "name": "ios-cloud-circle",
        "tag": "circle,cloud"
    },
    {
        "name": "ios-cloud-circle-outline",
        "tag": "circle,cloud"
    },
    {
        "name": "md-cloud-circle",
        "tag": "circle,cloud"
    },
    {
        "name": "ios-cloud-done",
        "tag": "cloud,done"
    },
    {
        "name": "ios-cloud-done-outline",
        "tag": "cloud,done"
    },
    {
        "name": "md-cloud-done",
        "tag": "cloud,done"
    },
    {
        "name": "ios-cloud-download",
        "tag": "cloud,download,storage"
    },
    {
        "name": "ios-cloud-download-outline",
        "tag": "cloud,download,storage"
    },
    {
        "name": "md-cloud-download",
        "tag": "cloud,download,storage"
    },
    {
        "name": "md-cloud-outline",
        "tag": "cloud,outline"
    },
    {
        "name": "ios-cloud-upload",
        "tag": "cloud,storage,upload"
    },
    {
        "name": "ios-cloud-upload-outline",
        "tag": "cloud,storage,upload"
    },
    {
        "name": "md-cloud-upload",
        "tag": "cloud,storage,upload"
    },
    {
        "name": "ios-cloudy",
        "tag": "cloudy,overcast,weather,whether"
    },
    {
        "name": "ios-cloudy-outline",
        "tag": "cloudy,overcast,weather,whether"
    },
    {
        "name": "md-cloudy",
        "tag": "cloudy,overcast,weather,whether"
    },
    {
        "name": "ios-cloudy-night",
        "tag": "cloudy,night,overcast,weather,whether"
    },
    {
        "name": "ios-cloudy-night-outline",
        "tag": "cloudy,night,overcast,weather,whether"
    },
    {
        "name": "md-cloudy-night",
        "tag": "cloudy,night,overcast,weather,whether"
    },
    {
        "name": "ios-code",
        "tag": "code,develop,hacker,program"
    },
    {
        "name": "md-code",
        "tag": "code,develop,hacker,program"
    },
    {
        "name": "ios-code-download",
        "tag": "code,develop,download,hacker,program"
    },
    {
        "name": "md-code-download",
        "tag": "code,develop,download,hacker,program"
    },
    {
        "name": "ios-code-working",
        "tag": "code,develop,hacker,program,working"
    },
    {
        "name": "md-code-working",
        "tag": "code,develop,hacker,program,working"
    },
    {
        "name": "logo-codepen",
        "tag": "codepen,logo"
    },
    {
        "name": "ios-cog",
        "tag": "cog,gear,options,settings"
    },
    {
        "name": "ios-cog-outline",
        "tag": "cog,gear,options,settings"
    },
    {
        "name": "md-cog",
        "tag": "cog,gear,options,settings"
    },
    {
        "name": "ios-color-fill",
        "tag": "color,fill"
    },
    {
        "name": "ios-color-fill-outline",
        "tag": "color,fill"
    },
    {
        "name": "md-color-fill",
        "tag": "color,fill"
    },
    {
        "name": "ios-color-filter",
        "tag": "color,filter"
    },
    {
        "name": "ios-color-filter-outline",
        "tag": "color,filter"
    },
    {
        "name": "md-color-filter",
        "tag": "color,filter"
    },
    {
        "name": "ios-color-palette",
        "tag": "color,palette"
    },
    {
        "name": "ios-color-palette-outline",
        "tag": "color,palette"
    },
    {
        "name": "md-color-palette",
        "tag": "color,palette"
    },
    {
        "name": "ios-color-wand",
        "tag": "color,wand"
    },
    {
        "name": "ios-color-wand-outline",
        "tag": "color,wand"
    },
    {
        "name": "md-color-wand",
        "tag": "color,wand"
    },
    {
        "name": "ios-compass",
        "tag": "compass,directions,location,navigation"
    },
    {
        "name": "ios-compass-outline",
        "tag": "compass,directions,location,navigation"
    },
    {
        "name": "md-compass",
        "tag": "compass,directions,location,navigation"
    },
    {
        "name": "ios-construct",
        "tag": "construct"
    },
    {
        "name": "ios-construct-outline",
        "tag": "construct"
    },
    {
        "name": "md-construct",
        "tag": "construct"
    },
    {
        "name": "ios-contact",
        "tag": "contact,people,users"
    },
    {
        "name": "ios-contact-outline",
        "tag": "contact,people,users"
    },
    {
        "name": "md-contact",
        "tag": "contact,people,users"
    },
    {
        "name": "ios-contacts",
        "tag": "contacts,people,users"
    },
    {
        "name": "ios-contacts-outline",
        "tag": "contacts,people,users"
    },
    {
        "name": "md-contacts",
        "tag": "contacts,people,users"
    },
    {
        "name": "ios-contract",
        "tag": "contract"
    },
    {
        "name": "md-contract",
        "tag": "contract"
    },
    {
        "name": "ios-contrast",
        "tag": "contrast,dark,images,levels,light,settings"
    },
    {
        "name": "md-contrast",
        "tag": "contrast,dark,images,levels,light,settings"
    },
    {
        "name": "ios-copy",
        "tag": "copy,duplicate,paper"
    },
    {
        "name": "ios-copy-outline",
        "tag": "copy,duplicate,paper"
    },
    {
        "name": "md-copy",
        "tag": "copy,duplicate,paper"
    },
    {
        "name": "ios-create",
        "tag": "create"
    },
    {
        "name": "ios-create-outline",
        "tag": "create"
    },
    {
        "name": "md-create",
        "tag": "create"
    },
    {
        "name": "ios-crop",
        "tag": "crop"
    },
    {
        "name": "ios-crop-outline",
        "tag": "crop"
    },
    {
        "name": "md-crop",
        "tag": "crop"
    },
    {
        "name": "logo-css3",
        "tag": "css3,logo"
    },
    {
        "name": "ios-cube",
        "tag": "box,container,cube,square"
    },
    {
        "name": "ios-cube-outline",
        "tag": "box,container,cube,square"
    },
    {
        "name": "md-cube",
        "tag": "box,container,cube,square"
    },
    {
        "name": "ios-cut",
        "tag": "cut"
    },
    {
        "name": "ios-cut-outline",
        "tag": "cut"
    },
    {
        "name": "md-cut",
        "tag": "cut"
    },
    {
        "name": "logo-designernews",
        "tag": "design,designernews,post,logo"
    },
    {
        "name": "ios-desktop",
        "tag": "desktop"
    },
    {
        "name": "ios-desktop-outline",
        "tag": "desktop"
    },
    {
        "name": "md-desktop",
        "tag": "desktop"
    },
    {
        "name": "ios-disc",
        "tag": "cd,disc,vinyl"
    },
    {
        "name": "ios-disc-outline",
        "tag": "cd,disc,vinyl"
    },
    {
        "name": "md-disc",
        "tag": "cd,disc,vinyl"
    },
    {
        "name": "ios-document",
        "tag": "document,file,paper"
    },
    {
        "name": "ios-document-outline",
        "tag": "document,file,paper"
    },
    {
        "name": "md-document",
        "tag": "document,file,paper"
    },
    {
        "name": "ios-done-all",
        "tag": "all,done"
    },
    {
        "name": "md-done-all",
        "tag": "all,done"
    },
    {
        "name": "ios-download",
        "tag": "download,export"
    },
    {
        "name": "ios-download-outline",
        "tag": "download,export"
    },
    {
        "name": "md-download",
        "tag": "download,export"
    },
    {
        "name": "logo-dribbble",
        "tag": "design,dribbble,logo"
    },
    {
        "name": "logo-dropbox",
        "tag": "dropbox,logo,upload"
    },
    {
        "name": "ios-easel",
        "tag": "easel"
    },
    {
        "name": "ios-easel-outline",
        "tag": "easel"
    },
    {
        "name": "md-easel",
        "tag": "easel"
    },
    {
        "name": "ios-egg",
        "tag": "baby,bird,birth,egg,twitter"
    },
    {
        "name": "ios-egg-outline",
        "tag": "baby,bird,birth,egg,twitter"
    },
    {
        "name": "md-egg",
        "tag": "baby,bird,birth,egg,twitter"
    },
    {
        "name": "logo-euro",
        "tag": "euro,logo"
    },
    {
        "name": "ios-exit",
        "tag": "exit"
    },
    {
        "name": "ios-exit-outline",
        "tag": "exit"
    },
    {
        "name": "md-exit",
        "tag": "exit"
    },
    {
        "name": "ios-expand",
        "tag": "expand"
    },
    {
        "name": "md-expand",
        "tag": "expand"
    },
    {
        "name": "ios-eye",
        "tag": "exposed,eye,look,see,view"
    },
    {
        "name": "ios-eye-outline",
        "tag": "exposed,eye,look,see,view"
    },
    {
        "name": "md-eye",
        "tag": "exposed,eye,look,see,view"
    },
    {
        "name": "ios-eye-off",
        "tag": "eye,off"
    },
    {
        "name": "ios-eye-off-outline",
        "tag": "eye,off"
    },
    {
        "name": "md-eye-off",
        "tag": "eye,off"
    },
    {
        "name": "logo-facebook",
        "tag": "facebook,like,post,share,logo"
    },
    {
        "name": "ios-fastforward",
        "tag": "fastforward,jump,next,skip"
    },
    {
        "name": "ios-fastforward-outline",
        "tag": "fastforward,jump,next,skip"
    },
    {
        "name": "md-fastforward",
        "tag": "fastforward,jump,next,skip"
    },
    {
        "name": "ios-female",
        "tag": "dudette,female,girl,lady"
    },
    {
        "name": "md-female",
        "tag": "dudette,female,girl,lady"
    },
    {
        "name": "ios-filing",
        "tag": "archive,filing"
    },
    {
        "name": "ios-filing-outline",
        "tag": "archive,filing"
    },
    {
        "name": "md-filing",
        "tag": "archive,filing"
    },
    {
        "name": "ios-film",
        "tag": "film"
    },
    {
        "name": "ios-film-outline",
        "tag": "film"
    },
    {
        "name": "md-film",
        "tag": "film"
    },
    {
        "name": "ios-finger-print",
        "tag": "finger,print"
    },
    {
        "name": "md-finger-print",
        "tag": "finger,print"
    },
    {
        "name": "ios-flag",
        "tag": "favorite,flag,marker"
    },
    {
        "name": "ios-flag-outline",
        "tag": "favorite,flag,marker"
    },
    {
        "name": "md-flag",
        "tag": "favorite,flag,marker"
    },
    {
        "name": "ios-flame",
        "tag": "fire,flame,heat,hot"
    },
    {
        "name": "ios-flame-outline",
        "tag": "fire,flame,heat,hot"
    },
    {
        "name": "md-flame",
        "tag": "fire,flame,heat,hot"
    },
    {
        "name": "ios-flash",
        "tag": "flash,lightning,weather,whether"
    },
    {
        "name": "ios-flash-outline",
        "tag": "flash,lightning,weather,whether"
    },
    {
        "name": "md-flash",
        "tag": "flash,lightning,weather,whether"
    },
    {
        "name": "ios-flask",
        "tag": "bubbles,flask,mixture,potion"
    },
    {
        "name": "ios-flask-outline",
        "tag": "bubbles,flask,mixture,potion"
    },
    {
        "name": "md-flask",
        "tag": "bubbles,flask,mixture,potion"
    },
    {
        "name": "ios-flower",
        "tag": "flower"
    },
    {
        "name": "ios-flower-outline",
        "tag": "flower"
    },
    {
        "name": "md-flower",
        "tag": "flower"
    },
    {
        "name": "ios-folder",
        "tag": "file,folder"
    },
    {
        "name": "ios-folder-outline",
        "tag": "file,folder"
    },
    {
        "name": "md-folder",
        "tag": "file,folder"
    },
    {
        "name": "ios-folder-open",
        "tag": "folder,open"
    },
    {
        "name": "ios-folder-open-outline",
        "tag": "folder,open"
    },
    {
        "name": "md-folder-open",
        "tag": "folder,open"
    },
    {
        "name": "ios-football",
        "tag": "football"
    },
    {
        "name": "ios-football-outline",
        "tag": "football"
    },
    {
        "name": "md-football",
        "tag": "football"
    },
    {
        "name": "logo-foursquare",
        "tag": "checkin,foursquare,logo"
    },
    {
        "name": "logo-freebsd-devil",
        "tag": "devil,freebsd,logo,unix"
    },
    {
        "name": "ios-funnel",
        "tag": "funnel,sort"
    },
    {
        "name": "ios-funnel-outline",
        "tag": "funnel,sort"
    },
    {
        "name": "md-funnel",
        "tag": "funnel,sort"
    },
    {
        "name": "ios-game-controller-a",
        "tag": "a,controller,fun,game"
    },
    {
        "name": "ios-game-controller-a-outline",
        "tag": "a,controller,fun,game"
    },
    {
        "name": "md-game-controller-a",
        "tag": "a,controller,fun,game"
    },
    {
        "name": "ios-game-controller-b",
        "tag": "b,controller,fun,game"
    },
    {
        "name": "ios-game-controller-b-outline",
        "tag": "b,controller,fun,game"
    },
    {
        "name": "md-game-controller-b",
        "tag": "b,controller,fun,game"
    },
    {
        "name": "ios-git-branch",
        "tag": "branch,git"
    },
    {
        "name": "md-git-branch",
        "tag": "branch,git"
    },
    {
        "name": "ios-git-commit",
        "tag": "commit,git"
    },
    {
        "name": "md-git-commit",
        "tag": "commit,git"
    },
    {
        "name": "ios-git-compare",
        "tag": "compare,git"
    },
    {
        "name": "md-git-compare",
        "tag": "compare,git"
    },
    {
        "name": "ios-git-merge",
        "tag": "git,merge"
    },
    {
        "name": "md-git-merge",
        "tag": "git,merge"
    },
    {
        "name": "ios-git-network",
        "tag": "git,network"
    },
    {
        "name": "md-git-network",
        "tag": "git,network"
    },
    {
        "name": "ios-git-pull-request",
        "tag": "git,pull,request"
    },
    {
        "name": "md-git-pull-request",
        "tag": "git,pull,request"
    },
    {
        "name": "logo-github",
        "tag": "code,github,logo"
    },
    {
        "name": "ios-glasses",
        "tag": "glasses,look,reading,see,steve"
    },
    {
        "name": "ios-glasses-outline",
        "tag": "glasses,look,reading,see,steve"
    },
    {
        "name": "md-glasses",
        "tag": "glasses,look,reading,see,steve"
    },
    {
        "name": "ios-globe",
        "tag": "globe"
    },
    {
        "name": "ios-globe-outline",
        "tag": "globe"
    },
    {
        "name": "md-globe",
        "tag": "globe"
    },
    {
        "name": "logo-google",
        "tag": "follow,google,post,share,logo"
    },
    {
        "name": "logo-googleplus",
        "tag": "follow,googleplus,post,share,logo"
    },
    {
        "name": "ios-grid",
        "tag": "grid,menu"
    },
    {
        "name": "ios-grid-outline",
        "tag": "grid,menu"
    },
    {
        "name": "md-grid",
        "tag": "grid,menu"
    },
    {
        "name": "logo-hackernews",
        "tag": "discuss,hackernews,karma,logo,upvotes"
    },
    {
        "name": "ios-hammer",
        "tag": "hammer,options,settings,tools"
    },
    {
        "name": "ios-hammer-outline",
        "tag": "hammer,options,settings,tools"
    },
    {
        "name": "md-hammer",
        "tag": "hammer,options,settings,tools"
    },
    {
        "name": "ios-hand",
        "tag": "hand,stop"
    },
    {
        "name": "ios-hand-outline",
        "tag": "hand,stop"
    },
    {
        "name": "md-hand",
        "tag": "hand,stop"
    },
    {
        "name": "ios-happy",
        "tag": "fun,good,happy,like,yes"
    },
    {
        "name": "ios-happy-outline",
        "tag": "fun,good,happy,like,yes"
    },
    {
        "name": "md-happy",
        "tag": "fun,good,happy,like,yes"
    },
    {
        "name": "ios-headset",
        "tag": "headset"
    },
    {
        "name": "ios-headset-outline",
        "tag": "headset"
    },
    {
        "name": "md-headset",
        "tag": "headset"
    },
    {
        "name": "ios-heart",
        "tag": "heart,love"
    },
    {
        "name": "ios-heart-outline",
        "tag": "heart,love"
    },
    {
        "name": "md-heart",
        "tag": "heart,love"
    },
    {
        "name": "md-heart-outline",
        "tag": "heart,outline"
    },
    {
        "name": "ios-help",
        "tag": "?,help,information,question"
    },
    {
        "name": "md-help",
        "tag": "?,help,information,question"
    },
    {
        "name": "ios-help-buoy",
        "tag": "?,buoy,help,question"
    },
    {
        "name": "ios-help-buoy-outline",
        "tag": "?,buoy,help,question"
    },
    {
        "name": "md-help-buoy",
        "tag": "?,buoy,help,question"
    },
    {
        "name": "ios-help-circle",
        "tag": "circle,help"
    },
    {
        "name": "ios-help-circle-outline",
        "tag": "circle,help"
    },
    {
        "name": "md-help-circle",
        "tag": "circle,help"
    },
    {
        "name": "ios-home",
        "tag": "home,house"
    },
    {
        "name": "ios-home-outline",
        "tag": "home,house"
    },
    {
        "name": "md-home",
        "tag": "home,house"
    },
    {
        "name": "logo-html5",
        "tag": "html5,logo"
    },
    {
        "name": "ios-ice-cream",
        "tag": "cream,ice"
    },
    {
        "name": "ios-ice-cream-outline",
        "tag": "cream,ice"
    },
    {
        "name": "md-ice-cream",
        "tag": "cream,ice"
    },
    {
        "name": "ios-image",
        "tag": "camera,image,photo"
    },
    {
        "name": "ios-image-outline",
        "tag": "camera,image,photo"
    },
    {
        "name": "md-image",
        "tag": "camera,image,photo"
    },
    {
        "name": "ios-images",
        "tag": "images,photo"
    },
    {
        "name": "ios-images-outline",
        "tag": "images,photo"
    },
    {
        "name": "md-images",
        "tag": "images,photo"
    },
    {
        "name": "ios-infinite",
        "tag": "forever,infinite,loop"
    },
    {
        "name": "ios-infinite-outline",
        "tag": "forever,infinite,loop"
    },
    {
        "name": "md-infinite",
        "tag": "forever,infinite,loop"
    },
    {
        "name": "ios-information",
        "tag": "help,information,knowledge"
    },
    {
        "name": "md-information",
        "tag": "help,information,knowledge"
    },
    {
        "name": "ios-information-circle",
        "tag": "circle,information"
    },
    {
        "name": "ios-information-circle-outline",
        "tag": "circle,information"
    },
    {
        "name": "md-information-circle",
        "tag": "circle,information"
    },
    {
        "name": "logo-instagram",
        "tag": "camera,instagram,photo,logo"
    },
    {
        "name": "ios-ionic",
        "tag": "badass,framework,hawt,ionic,sexy"
    },
    {
        "name": "ios-ionic-outline",
        "tag": "badass,framework,hawt,ionic,sexy"
    },
    {
        "name": "md-ionic",
        "tag": "badass,framework,hawt,ionic,sexy"
    },
    {
        "name": "ios-ionitron",
        "tag": "ionitron"
    },
    {
        "name": "ios-ionitron-outline",
        "tag": "ionitron"
    },
    {
        "name": "md-ionitron",
        "tag": "ionitron"
    },
    {
        "name": "logo-javascript",
        "tag": "javascript,logo"
    },
    {
        "name": "ios-jet",
        "tag": "fly,jet,plane"
    },
    {
        "name": "ios-jet-outline",
        "tag": "fly,jet,plane"
    },
    {
        "name": "md-jet",
        "tag": "fly,jet,plane"
    },
    {
        "name": "ios-key",
        "tag": "access,key"
    },
    {
        "name": "ios-key-outline",
        "tag": "access,key"
    },
    {
        "name": "md-key",
        "tag": "access,key"
    },
    {
        "name": "ios-keypad",
        "tag": "keypad,type"
    },
    {
        "name": "ios-keypad-outline",
        "tag": "keypad,type"
    },
    {
        "name": "md-keypad",
        "tag": "keypad,type"
    },
    {
        "name": "ios-laptop",
        "tag": "apple,laptop,macbook,osx"
    },
    {
        "name": "md-laptop",
        "tag": "apple,laptop,macbook,osx"
    },
    {
        "name": "ios-leaf",
        "tag": "green,leaf,nature,plant,recycle"
    },
    {
        "name": "ios-leaf-outline",
        "tag": "green,leaf,nature,plant,recycle"
    },
    {
        "name": "md-leaf",
        "tag": "green,leaf,nature,plant,recycle"
    },
    {
        "name": "ios-link",
        "tag": "anchor,attach,chain,href,link"
    },
    {
        "name": "ios-link-outline",
        "tag": "anchor,attach,chain,href,link"
    },
    {
        "name": "md-link",
        "tag": "anchor,attach,chain,href,link"
    },
    {
        "name": "logo-linkedin",
        "tag": "connect,linkedin,logo"
    },
    {
        "name": "ios-list",
        "tag": "list"
    },
    {
        "name": "md-list",
        "tag": "list"
    },
    {
        "name": "ios-list-box",
        "tag": "box,list"
    },
    {
        "name": "ios-list-box-outline",
        "tag": "box,list"
    },
    {
        "name": "md-list-box",
        "tag": "box,list"
    },
    {
        "name": "ios-locate",
        "tag": "gps,locate,maps,navigate"
    },
    {
        "name": "ios-locate-outline",
        "tag": "gps,locate,maps,navigate"
    },
    {
        "name": "md-locate",
        "tag": "gps,locate,maps,navigate"
    },
    {
        "name": "ios-lock",
        "tag": "lock,privacy"
    },
    {
        "name": "ios-lock-outline",
        "tag": "lock,privacy"
    },
    {
        "name": "md-lock",
        "tag": "lock,privacy"
    },
    {
        "name": "ios-log-in",
        "tag": "in,log,signin"
    },
    {
        "name": "md-log-in",
        "tag": "in,log,signin"
    },
    {
        "name": "ios-log-out",
        "tag": "log,out,signout"
    },
    {
        "name": "md-log-out",
        "tag": "log,out,signout"
    },
    {
        "name": "ios-magnet",
        "tag": "attraction,magnet,sticky"
    },
    {
        "name": "ios-magnet-outline",
        "tag": "attraction,magnet,sticky"
    },
    {
        "name": "md-magnet",
        "tag": "attraction,magnet,sticky"
    },
    {
        "name": "ios-mail",
        "tag": "email,mail"
    },
    {
        "name": "ios-mail-outline",
        "tag": "email,mail"
    },
    {
        "name": "md-mail",
        "tag": "email,mail"
    },
    {
        "name": "ios-mail-open",
        "tag": "mail,open"
    },
    {
        "name": "ios-mail-open-outline",
        "tag": "mail,open"
    },
    {
        "name": "md-mail-open",
        "tag": "mail,open"
    },
    {
        "name": "ios-male",
        "tag": "boy,dude,guy,male,male"
    },
    {
        "name": "md-male",
        "tag": "boy,dude,guy,male,male"
    },
    {
        "name": "ios-man",
        "tag": "boy,dude,guy,male,man"
    },
    {
        "name": "ios-man-outline",
        "tag": "boy,dude,guy,male,man"
    },
    {
        "name": "md-man",
        "tag": "boy,dude,guy,male,man"
    },
    {
        "name": "ios-map",
        "tag": "gps,map,navigation,pin"
    },
    {
        "name": "ios-map-outline",
        "tag": "gps,map,navigation,pin"
    },
    {
        "name": "md-map",
        "tag": "gps,map,navigation,pin"
    },
    {
        "name": "logo-markdown",
        "tag": "markdown,logo"
    },
    {
        "name": "ios-medal",
        "tag": "medal"
    },
    {
        "name": "ios-medal-outline",
        "tag": "medal"
    },
    {
        "name": "md-medal",
        "tag": "medal"
    },
    {
        "name": "ios-medical",
        "tag": "medical"
    },
    {
        "name": "ios-medical-outline",
        "tag": "medical"
    },
    {
        "name": "md-medical",
        "tag": "medical"
    },
    {
        "name": "ios-medkit",
        "tag": "case,disease,firstaid,health,medkit,sick"
    },
    {
        "name": "ios-medkit-outline",
        "tag": "case,disease,firstaid,health,medkit,sick"
    },
    {
        "name": "md-medkit",
        "tag": "case,disease,firstaid,health,medkit,sick"
    },
    {
        "name": "ios-megaphone",
        "tag": "megaphone"
    },
    {
        "name": "ios-megaphone-outline",
        "tag": "megaphone"
    },
    {
        "name": "md-megaphone",
        "tag": "megaphone"
    },
    {
        "name": "ios-menu",
        "tag": "menu"
    },
    {
        "name": "ios-menu-outline",
        "tag": "menu"
    },
    {
        "name": "md-menu",
        "tag": "menu"
    },
    {
        "name": "ios-mic",
        "tag": "mic,noise,sound,speaker,talk"
    },
    {
        "name": "ios-mic-outline",
        "tag": "mic,noise,sound,speaker,talk"
    },
    {
        "name": "md-mic",
        "tag": "mic,noise,sound,speaker,talk"
    },
    {
        "name": "ios-mic-off",
        "tag": "mic,noise,off,sound,speaker,talk"
    },
    {
        "name": "ios-mic-off-outline",
        "tag": "mic,noise,off,sound,speaker,talk"
    },
    {
        "name": "md-mic-off",
        "tag": "mic,noise,off,sound,speaker,talk"
    },
    {
        "name": "ios-microphone",
        "tag": "microphone,music,noise,recorde,sound,speak"
    },
    {
        "name": "ios-microphone-outline",
        "tag": "microphone,music,noise,recorde,sound,speak"
    },
    {
        "name": "md-microphone",
        "tag": "microphone,music,noise,recorde,sound,speak"
    },
    {
        "name": "ios-moon",
        "tag": "dark,moon,night,sky"
    },
    {
        "name": "ios-moon-outline",
        "tag": "dark,moon,night,sky"
    },
    {
        "name": "md-moon",
        "tag": "dark,moon,night,sky"
    },
    {
        "name": "ios-more",
        "tag": "more,options"
    },
    {
        "name": "ios-more-outline",
        "tag": "more,options"
    },
    {
        "name": "md-more",
        "tag": "more,options"
    },
    {
        "name": "ios-move",
        "tag": "move"
    },
    {
        "name": "md-move",
        "tag": "move"
    },
    {
        "name": "ios-musical-note",
        "tag": "listening,musical,noise,note,play,sound"
    },
    {
        "name": "ios-musical-note-outline",
        "tag": "listening,musical,noise,note,play,sound"
    },
    {
        "name": "md-musical-note",
        "tag": "listening,musical,noise,note,play,sound"
    },
    {
        "name": "ios-musical-notes",
        "tag": "listening,musical,noise,notes,play,sound"
    },
    {
        "name": "ios-musical-notes-outline",
        "tag": "listening,musical,noise,notes,play,sound"
    },
    {
        "name": "md-musical-notes",
        "tag": "listening,musical,noise,notes,play,sound"
    },
    {
        "name": "ios-navigate",
        "tag": "gps,location,map,navigate,pin"
    },
    {
        "name": "ios-navigate-outline",
        "tag": "gps,location,map,navigate,pin"
    },
    {
        "name": "md-navigate",
        "tag": "gps,location,map,navigate,pin"
    },
    {
        "name": "ios-no-smoking",
        "tag": "cancer,cigarette,danger,no,smoking,warning"
    },
    {
        "name": "ios-no-smoking-outline",
        "tag": "cancer,cigarette,danger,no,smoking,warning"
    },
    {
        "name": "md-no-smoking",
        "tag": "cancer,cigarette,danger,no,smoking,warning"
    },
    {
        "name": "logo-nodejs",
        "tag": "nodejs,logo"
    },
    {
        "name": "ios-notifications",
        "tag": "notifications,push"
    },
    {
        "name": "ios-notifications-outline",
        "tag": "notifications,push,outline"
    },
    {
        "name": "md-notifications",
        "tag": "notifications,push"
    },
    {
        "name": "ios-notifications-off",
        "tag": "notifications,off,push"
    },
    {
        "name": "ios-notifications-off-outline",
        "tag": "notifications,off,push"
    },
    {
        "name": "md-notifications-off",
        "tag": "notifications,off,push"
    },
    {
        "name": "md-notifications-outline",
        "tag": "notifications,outline,push"
    },
    {
        "name": "ios-nuclear",
        "tag": "danger,hazard,nuclear,warning"
    },
    {
        "name": "ios-nuclear-outline",
        "tag": "danger,hazard,nuclear,warning"
    },
    {
        "name": "md-nuclear",
        "tag": "danger,hazard,nuclear,warning"
    },
    {
        "name": "ios-nutrition",
        "tag": "nutrition"
    },
    {
        "name": "ios-nutrition-outline",
        "tag": "nutrition"
    },
    {
        "name": "md-nutrition",
        "tag": "nutrition"
    },
    {
        "name": "logo-octocat",
        "tag": "octocat,logo"
    },
    {
        "name": "ios-open",
        "tag": "open"
    },
    {
        "name": "ios-open-outline",
        "tag": "open"
    },
    {
        "name": "md-open",
        "tag": "open"
    },
    {
        "name": "ios-options",
        "tag": "options"
    },
    {
        "name": "ios-options-outline",
        "tag": "options"
    },
    {
        "name": "md-options",
        "tag": "options"
    },
    {
        "name": "ios-outlet",
        "tag": "computer,digital,electricity,outlet"
    },
    {
        "name": "ios-outlet-outline",
        "tag": "computer,digital,electricity,outlet"
    },
    {
        "name": "md-outlet",
        "tag": "computer,digital,electricity,outlet"
    },
    {
        "name": "ios-paper",
        "tag": "feed,paper,paper"
    },
    {
        "name": "ios-paper-outline",
        "tag": "feed,paper,paper"
    },
    {
        "name": "md-paper",
        "tag": "feed,paper,paper"
    },
    {
        "name": "ios-paper-plane",
        "tag": "paper,plane"
    },
    {
        "name": "ios-paper-plane-outline",
        "tag": "paper,plane"
    },
    {
        "name": "md-paper-plane",
        "tag": "paper,plane"
    },
    {
        "name": "ios-partly-sunny",
        "tag": "partly,sunny"
    },
    {
        "name": "ios-partly-sunny-outline",
        "tag": "partly,sunny"
    },
    {
        "name": "md-partly-sunny",
        "tag": "partly,sunny"
    },
    {
        "name": "ios-pause",
        "tag": "break,freeze,hold,music,pause"
    },
    {
        "name": "ios-pause-outline",
        "tag": "break,freeze,hold,music,pause"
    },
    {
        "name": "md-pause",
        "tag": "break,freeze,hold,music,pause"
    },
    {
        "name": "ios-paw",
        "tag": "paw"
    },
    {
        "name": "ios-paw-outline",
        "tag": "paw"
    },
    {
        "name": "md-paw",
        "tag": "paw"
    },
    {
        "name": "ios-people",
        "tag": "head,human,people,person,stalker,users"
    },
    {
        "name": "ios-people-outline",
        "tag": "head,human,people,person,stalker,users"
    },
    {
        "name": "md-people",
        "tag": "head,human,people,person,stalker,users"
    },
    {
        "name": "ios-person",
        "tag": "head,human,person,staff,users"
    },
    {
        "name": "ios-person-outline",
        "tag": "head,human,person,staff,users"
    },
    {
        "name": "md-person",
        "tag": "head,human,person,staff,users"
    },
    {
        "name": "ios-person-add",
        "tag": "add,head,human,member,new,person,staff,users"
    },
    {
        "name": "ios-person-add-outline",
        "tag": "add,head,human,member,new,person,staff,users"
    },
    {
        "name": "md-person-add",
        "tag": "add,head,human,member,new,person,staff,users"
    },
    {
        "name": "ios-phone-landscape",
        "tag": "landscape,phone"
    },
    {
        "name": "md-phone-landscape",
        "tag": "landscape,phone"
    },
    {
        "name": "ios-phone-portrait",
        "tag": "phone,portrait"
    },
    {
        "name": "md-phone-portrait",
        "tag": "phone,portrait"
    },
    {
        "name": "ios-photos",
        "tag": "images,photos,square,stills"
    },
    {
        "name": "ios-photos-outline",
        "tag": "images,photos,square,stills"
    },
    {
        "name": "md-photos",
        "tag": "images,photos,square,stills"
    },
    {
        "name": "ios-pie",
        "tag": "cog,options,pie,settings"
    },
    {
        "name": "ios-pie-outline",
        "tag": "cog,options,pie,settings"
    },
    {
        "name": "md-pie",
        "tag": "cog,options,pie,settings"
    },
    {
        "name": "ios-pin",
        "tag": "gps,navigation,pin"
    },
    {
        "name": "ios-pin-outline",
        "tag": "gps,navigation,pin"
    },
    {
        "name": "md-pin",
        "tag": "gps,navigation,pin"
    },
    {
        "name": "ios-pint",
        "tag": "pint"
    },
    {
        "name": "ios-pint-outline",
        "tag": "pint"
    },
    {
        "name": "md-pint",
        "tag": "pint"
    },
    {
        "name": "logo-pinterest",
        "tag": "pinterest,logo"
    },
    {
        "name": "ios-pizza",
        "tag": "drink,eat,food,pizza"
    },
    {
        "name": "ios-pizza-outline",
        "tag": "drink,eat,food,pizza"
    },
    {
        "name": "md-pizza",
        "tag": "drink,eat,food,pizza"
    },
    {
        "name": "ios-plane",
        "tag": "fly,jet,plane"
    },
    {
        "name": "ios-plane-outline",
        "tag": "fly,jet,plane"
    },
    {
        "name": "md-plane",
        "tag": "fly,jet,plane"
    },
    {
        "name": "ios-planet",
        "tag": "globe,home,nature,planet,planet,space"
    },
    {
        "name": "ios-planet-outline",
        "tag": "globe,home,nature,planet,planet,space"
    },
    {
        "name": "md-planet",
        "tag": "globe,home,nature,planet,planet,space"
    },
    {
        "name": "ios-play",
        "tag": "arrow,music,play,right,watch"
    },
    {
        "name": "ios-play-outline",
        "tag": "arrow,music,play,right,watch"
    },
    {
        "name": "md-play",
        "tag": "arrow,music,play,right,watch"
    },
    {
        "name": "logo-playstation",
        "tag": "fun,games,playstation,logo"
    },
    {
        "name": "ios-podium",
        "tag": "award,compete,competition,lose,podium,win"
    },
    {
        "name": "ios-podium-outline",
        "tag": "award,compete,competition,lose,podium,win"
    },
    {
        "name": "md-podium",
        "tag": "award,compete,competition,lose,podium,win"
    },
    {
        "name": "ios-power",
        "tag": "off,on,power"
    },
    {
        "name": "ios-power-outline",
        "tag": "off,on,power"
    },
    {
        "name": "md-power",
        "tag": "off,on,power"
    },
    {
        "name": "ios-pricetag",
        "tag": "$,commerce,items,money,pricetag,shopping"
    },
    {
        "name": "ios-pricetag-outline",
        "tag": "$,commerce,items,money,pricetag,shopping"
    },
    {
        "name": "md-pricetag",
        "tag": "$,commerce,items,money,pricetag,shopping"
    },
    {
        "name": "ios-pricetags",
        "tag": "$,commerce,items,money,pricetags,shopping"
    },
    {
        "name": "ios-pricetags-outline",
        "tag": "$,commerce,items,money,pricetags,shopping"
    },
    {
        "name": "md-pricetags",
        "tag": "$,commerce,items,money,pricetags,shopping"
    },
    {
        "name": "ios-print",
        "tag": "print"
    },
    {
        "name": "ios-print-outline",
        "tag": "print"
    },
    {
        "name": "md-print",
        "tag": "print"
    },
    {
        "name": "ios-pulse",
        "tag": "hot,live,pulse,rate"
    },
    {
        "name": "ios-pulse-outline",
        "tag": "hot,live,pulse,rate"
    },
    {
        "name": "md-pulse",
        "tag": "hot,live,pulse,rate"
    },
    {
        "name": "logo-python",
        "tag": "python,logo"
    },
    {
        "name": "ios-qr-scanner",
        "tag": "qr,reader,scanner"
    },
    {
        "name": "md-qr-scanner",
        "tag": "qr,reader,scanner"
    },
    {
        "name": "ios-quote",
        "tag": "chat,quotation,quote"
    },
    {
        "name": "ios-quote-outline",
        "tag": "chat,quotation,quote"
    },
    {
        "name": "md-quote",
        "tag": "chat,quotation,quote"
    },
    {
        "name": "ios-radio",
        "tag": "radio"
    },
    {
        "name": "ios-radio-outline",
        "tag": "radio"
    },
    {
        "name": "md-radio",
        "tag": "radio"
    },
    {
        "name": "ios-radio-button-off",
        "tag": "button,off,radio"
    },
    {
        "name": "md-radio-button-off",
        "tag": "button,off,radio"
    },
    {
        "name": "ios-radio-button-on",
        "tag": "button,on,radio"
    },
    {
        "name": "md-radio-button-on",
        "tag": "button,on,radio"
    },
    {
        "name": "ios-rainy",
        "tag": "cloud,rainy,water,weather,whether"
    },
    {
        "name": "ios-rainy-outline",
        "tag": "cloud,rainy,water,weather,whether"
    },
    {
        "name": "md-rainy",
        "tag": "cloud,rainy,water,weather,whether"
    },
    {
        "name": "ios-recording",
        "tag": "film,recording,tape,voicemail"
    },
    {
        "name": "ios-recording-outline",
        "tag": "film,recording,tape,voicemail"
    },
    {
        "name": "md-recording",
        "tag": "film,recording,tape,voicemail"
    },
    {
        "name": "logo-reddit",
        "tag": "karma,news,reddit,logo,upvotes"
    },
    {
        "name": "ios-redo",
        "tag": "forward,redo"
    },
    {
        "name": "ios-redo-outline",
        "tag": "forward,redo"
    },
    {
        "name": "md-redo",
        "tag": "forward,redo"
    },
    {
        "name": "ios-refresh",
        "tag": "refresh,reload,renew,reset"
    },
    {
        "name": "md-refresh",
        "tag": "refresh,reload,renew,reset"
    },
    {
        "name": "ios-refresh-circle",
        "tag": "circle,refresh"
    },
    {
        "name": "ios-refresh-circle-outline",
        "tag": "circle,refresh"
    },
    {
        "name": "md-refresh-circle",
        "tag": "circle,refresh"
    },
    {
        "name": "ios-remove",
        "tag": "minus,remove,subtract"
    },
    {
        "name": "md-remove",
        "tag": "minus,remove,subtract"
    },
    {
        "name": "ios-remove-circle",
        "tag": "circle,remove"
    },
    {
        "name": "ios-remove-circle-outline",
        "tag": "circle,remove"
    },
    {
        "name": "md-remove-circle",
        "tag": "circle,remove"
    },
    {
        "name": "ios-reorder",
        "tag": "reorder"
    },
    {
        "name": "md-reorder",
        "tag": "reorder"
    },
    {
        "name": "ios-repeat",
        "tag": "repeat"
    },
    {
        "name": "md-repeat",
        "tag": "repeat"
    },
    {
        "name": "ios-resize",
        "tag": "resize"
    },
    {
        "name": "md-resize",
        "tag": "resize"
    },
    {
        "name": "ios-restaurant",
        "tag": "restaurant"
    },
    {
        "name": "ios-restaurant-outline",
        "tag": "restaurant"
    },
    {
        "name": "md-restaurant",
        "tag": "restaurant"
    },
    {
        "name": "ios-return-left",
        "tag": "left,return"
    },
    {
        "name": "md-return-left",
        "tag": "left,return"
    },
    {
        "name": "ios-return-right",
        "tag": "return,right"
    },
    {
        "name": "md-return-right",
        "tag": "return,right"
    },
    {
        "name": "ios-reverse-camera",
        "tag": "camera,picture,reverse"
    },
    {
        "name": "ios-reverse-camera-outline",
        "tag": "camera,picture,reverse"
    },
    {
        "name": "md-reverse-camera",
        "tag": "camera,picture,reverse"
    },
    {
        "name": "ios-rewind",
        "tag": "back,music,previous,rewind"
    },
    {
        "name": "ios-rewind-outline",
        "tag": "back,music,previous,rewind"
    },
    {
        "name": "md-rewind",
        "tag": "back,music,previous,rewind"
    },
    {
        "name": "ios-ribbon",
        "tag": "ribbon"
    },
    {
        "name": "ios-ribbon-outline",
        "tag": "ribbon"
    },
    {
        "name": "md-ribbon",
        "tag": "ribbon"
    },
    {
        "name": "ios-rose",
        "tag": "rose"
    },
    {
        "name": "ios-rose-outline",
        "tag": "rose"
    },
    {
        "name": "md-rose",
        "tag": "rose"
    },
    {
        "name": "logo-rss",
        "tag": "blogging,rss,logo"
    },
    {
        "name": "ios-sad",
        "tag": "bad,cry,no,sad"
    },
    {
        "name": "ios-sad-outline",
        "tag": "bad,cry,no,sad"
    },
    {
        "name": "md-sad",
        "tag": "bad,cry,no,sad"
    },
    {
        "name": "logo-sass",
        "tag": "sass,logo"
    },
    {
        "name": "ios-school",
        "tag": "school"
    },
    {
        "name": "ios-school-outline",
        "tag": "school"
    },
    {
        "name": "md-school",
        "tag": "school"
    },
    {
        "name": "ios-search",
        "tag": "magnifyingglass,search"
    },
    {
        "name": "ios-search-outline",
        "tag": "magnifyingglass,search"
    },
    {
        "name": "md-search",
        "tag": "magnifyingglass,search"
    },
    {
        "name": "ios-send",
        "tag": "email,paper,send,push"
    },
    {
        "name": "ios-send-outline",
        "tag": "email,paper,send,push"
    },
    {
        "name": "md-send",
        "tag": "email,paper,send,push"
    },
    {
        "name": "ios-settings",
        "tag": "options,settings"
    },
    {
        "name": "ios-settings-outline",
        "tag": "options,settings"
    },
    {
        "name": "md-settings",
        "tag": "options,settings"
    },
    {
        "name": "ios-share",
        "tag": "share"
    },
    {
        "name": "ios-share-outline",
        "tag": "share"
    },
    {
        "name": "md-share",
        "tag": "share"
    },
    {
        "name": "ios-share-alt",
        "tag": "alt,share"
    },
    {
        "name": "ios-share-alt-outline",
        "tag": "alt,share"
    },
    {
        "name": "md-share-alt",
        "tag": "alt,share"
    },
    {
        "name": "ios-shirt",
        "tag": "shirt"
    },
    {
        "name": "ios-shirt-outline",
        "tag": "shirt"
    },
    {
        "name": "md-shirt",
        "tag": "shirt"
    },
    {
        "name": "ios-shuffle",
        "tag": "random,shuffle"
    },
    {
        "name": "md-shuffle",
        "tag": "random,shuffle"
    },
    {
        "name": "ios-skip-backward",
        "tag": "backward,music,previous,skip"
    },
    {
        "name": "ios-skip-backward-outline",
        "tag": "backward,music,previous,skip"
    },
    {
        "name": "md-skip-backward",
        "tag": "backward,music,previous,skip"
    },
    {
        "name": "ios-skip-forward",
        "tag": "forward,music,next,skip"
    },
    {
        "name": "ios-skip-forward-outline",
        "tag": "forward,music,next,skip"
    },
    {
        "name": "md-skip-forward",
        "tag": "forward,music,next,skip"
    },
    {
        "name": "logo-skype",
        "tag": "call,skype,logo"
    },
    {
        "name": "logo-snapchat",
        "tag": "snapchat,logo"
    },
    {
        "name": "ios-snow",
        "tag": "snow"
    },
    {
        "name": "ios-snow-outline",
        "tag": "snow"
    },
    {
        "name": "md-snow",
        "tag": "snow"
    },
    {
        "name": "ios-speedometer",
        "tag": "drive,level,speed,speedometer"
    },
    {
        "name": "ios-speedometer-outline",
        "tag": "drive,level,speed,speedometer"
    },
    {
        "name": "md-speedometer",
        "tag": "drive,level,speed,speedometer"
    },
    {
        "name": "ios-square",
        "tag": "square"
    },
    {
        "name": "ios-square-outline",
        "tag": "square"
    },
    {
        "name": "md-square",
        "tag": "square"
    },
    {
        "name": "md-square-outline",
        "tag": "square,outline"
    },
    {
        "name": "ios-star",
        "tag": "favorite,star"
    },
    {
        "name": "ios-star-outline",
        "tag": "favorite,star"
    },
    {
        "name": "md-star",
        "tag": "favorite,star"
    },
    {
        "name": "ios-star-half",
        "tag": "favorite,half,rate,star"
    },
    {
        "name": "md-star-half",
        "tag": "favorite,half,rate,star"
    },
    {
        "name": "md-star-outline",
        "tag": "star,outline"
    },
    {
        "name": "ios-stats",
        "tag": "stats"
    },
    {
        "name": "ios-stats-outline",
        "tag": "stats"
    },
    {
        "name": "md-stats",
        "tag": "stats"
    },
    {
        "name": "logo-steam",
        "tag": "fun,games,logo,steam"
    },
    {
        "name": "ios-stopwatch",
        "tag": "stopwatch"
    },
    {
        "name": "ios-stopwatch-outline",
        "tag": "stopwatch"
    },
    {
        "name": "md-stopwatch",
        "tag": "stopwatch"
    },
    {
        "name": "ios-subway",
        "tag": "subway"
    },
    {
        "name": "ios-subway-outline",
        "tag": "subway"
    },
    {
        "name": "md-subway",
        "tag": "subway"
    },
    {
        "name": "ios-sunny",
        "tag": "light,sky,sunny,weather,whether"
    },
    {
        "name": "ios-sunny-outline",
        "tag": "light,sky,sunny,weather,whether"
    },
    {
        "name": "md-sunny",
        "tag": "light,sky,sunny,weather,whether"
    },
    {
        "name": "ios-swap",
        "tag": "swap"
    },
    {
        "name": "md-swap",
        "tag": "swap"
    },
    {
        "name": "ios-switch",
        "tag": "switch"
    },
    {
        "name": "ios-switch-outline",
        "tag": "switch"
    },
    {
        "name": "md-switch",
        "tag": "switch"
    },
    {
        "name": "ios-sync",
        "tag": "sync"
    },
    {
        "name": "md-sync",
        "tag": "sync"
    },
    {
        "name": "ios-tablet-landscape",
        "tag": "landscape,tablet"
    },
    {
        "name": "md-tablet-landscape",
        "tag": "landscape,tablet"
    },
    {
        "name": "ios-tablet-portrait",
        "tag": "portrait,tablet"
    },
    {
        "name": "md-tablet-portrait",
        "tag": "portrait,tablet"
    },
    {
        "name": "ios-tennisball",
        "tag": "tennisball"
    },
    {
        "name": "ios-tennisball-outline",
        "tag": "tennisball"
    },
    {
        "name": "md-tennisball",
        "tag": "tennisball"
    },
    {
        "name": "ios-text",
        "tag": "text"
    },
    {
        "name": "ios-text-outline",
        "tag": "text"
    },
    {
        "name": "md-text",
        "tag": "text"
    },
    {
        "name": "ios-thermometer",
        "tag": "cold,heat,hot,mercury,temperature,thermometer"
    },
    {
        "name": "ios-thermometer-outline",
        "tag": "cold,heat,hot,mercury,temperature,thermometer"
    },
    {
        "name": "md-thermometer",
        "tag": "cold,heat,hot,mercury,temperature,thermometer"
    },
    {
        "name": "ios-thumbs-down",
        "tag": "down,thumbs"
    },
    {
        "name": "ios-thumbs-down-outline",
        "tag": "down,thumbs"
    },
    {
        "name": "md-thumbs-down",
        "tag": "down,thumbs"
    },
    {
        "name": "ios-thumbs-up",
        "tag": "thumbs,up"
    },
    {
        "name": "ios-thumbs-up-outline",
        "tag": "thumbs,up"
    },
    {
        "name": "md-thumbs-up",
        "tag": "thumbs,up"
    },
    {
        "name": "ios-thunderstorm",
        "tag": "cloudy,lightning,overcast,rain,sky,storm,thunderstorm,weather,whether"
    },
    {
        "name": "ios-thunderstorm-outline",
        "tag": "cloudy,lightning,overcast,rain,sky,storm,thunderstorm,weather,whether"
    },
    {
        "name": "md-thunderstorm",
        "tag": "cloudy,lightning,overcast,rain,sky,storm,thunderstorm,weather,whether"
    },
    {
        "name": "ios-time",
        "tag": "clock,hour,minute,second,time,watch"
    },
    {
        "name": "ios-time-outline",
        "tag": "clock,hour,minute,second,time,watch"
    },
    {
        "name": "md-time",
        "tag": "clock,hour,minute,second,time,watch"
    },
    {
        "name": "ios-timer",
        "tag": "clock,timer"
    },
    {
        "name": "ios-timer-outline",
        "tag": "clock,timer"
    },
    {
        "name": "md-timer",
        "tag": "clock,timer"
    },
    {
        "name": "ios-train",
        "tag": "train"
    },
    {
        "name": "ios-train-outline",
        "tag": "train"
    },
    {
        "name": "md-train",
        "tag": "train"
    },
    {
        "name": "ios-transgender",
        "tag": "transgender"
    },
    {
        "name": "md-transgender",
        "tag": "transgender"
    },
    {
        "name": "ios-trash",
        "tag": "close,delete,remove,trash"
    },
    {
        "name": "ios-trash-outline",
        "tag": "close,delete,remove,trash"
    },
    {
        "name": "md-trash",
        "tag": "close,delete,remove,trash"
    },
    {
        "name": "ios-trending-down",
        "tag": "down,trending"
    },
    {
        "name": "md-trending-down",
        "tag": "down,trending"
    },
    {
        "name": "ios-trending-up",
        "tag": "trending,up"
    },
    {
        "name": "md-trending-up",
        "tag": "trending,up"
    },
    {
        "name": "ios-trophy",
        "tag": "award,compete,competition,lose,trophy,win"
    },
    {
        "name": "ios-trophy-outline",
        "tag": "award,compete,competition,lose,trophy,win"
    },
    {
        "name": "md-trophy",
        "tag": "award,compete,competition,lose,trophy,win"
    },
    {
        "name": "logo-tumblr",
        "tag": "blogging,logo,tumblr"
    },
    {
        "name": "logo-tux",
        "tag": "linux,opensource,logo,tux"
    },
    {
        "name": "logo-twitch",
        "tag": "logo,twitch"
    },
    {
        "name": "logo-twitter",
        "tag": "follow,post,share,logo,twitter"
    },
    {
        "name": "ios-umbrella",
        "tag": "dry,rain,shelter,umbrella,wet"
    },
    {
        "name": "ios-umbrella-outline",
        "tag": "dry,rain,shelter,umbrella,wet"
    },
    {
        "name": "md-umbrella",
        "tag": "dry,rain,shelter,umbrella,wet"
    },
    {
        "name": "ios-undo",
        "tag": "reply,undo"
    },
    {
        "name": "ios-undo-outline",
        "tag": "reply,undo"
    },
    {
        "name": "md-undo",
        "tag": "reply,undo"
    },
    {
        "name": "ios-unlock",
        "tag": "unlock"
    },
    {
        "name": "ios-unlock-outline",
        "tag": "unlock"
    },
    {
        "name": "md-unlock",
        "tag": "unlock"
    },
    {
        "name": "logo-usd",
        "tag": "cash,currency,money,logo,trade,usd"
    },
    {
        "name": "ios-videocam",
        "tag": "camera,film,movie,videocam"
    },
    {
        "name": "ios-videocam-outline",
        "tag": "camera,film,movie,videocam"
    },
    {
        "name": "md-videocam",
        "tag": "camera,film,movie,videocam"
    },
    {
        "name": "logo-vimeo",
        "tag": "share,logo,video,view,vimeo,watch"
    },
    {
        "name": "ios-volume-down",
        "tag": "down,volume"
    },
    {
        "name": "md-volume-down",
        "tag": "down,volume"
    },
    {
        "name": "ios-volume-mute",
        "tag": "mute,sound,volume"
    },
    {
        "name": "md-volume-mute",
        "tag": "mute,sound,volume"
    },
    {
        "name": "ios-volume-off",
        "tag": "off,volume"
    },
    {
        "name": "md-volume-off",
        "tag": "off,volume"
    },
    {
        "name": "ios-volume-up",
        "tag": "up,volume"
    },
    {
        "name": "md-volume-up",
        "tag": "up,volume"
    },
    {
        "name": "ios-walk",
        "tag": "walk"
    },
    {
        "name": "md-walk",
        "tag": "walk"
    },
    {
        "name": "ios-warning",
        "tag": "warning"
    },
    {
        "name": "ios-warning-outline",
        "tag": "warning"
    },
    {
        "name": "md-warning",
        "tag": "warning"
    },
    {
        "name": "ios-watch",
        "tag": "watch"
    },
    {
        "name": "md-watch",
        "tag": "watch"
    },
    {
        "name": "ios-water",
        "tag": "water"
    },
    {
        "name": "ios-water-outline",
        "tag": "water"
    },
    {
        "name": "md-water",
        "tag": "water"
    },
    {
        "name": "logo-whatsapp",
        "tag": "logo,whatsapp"
    },
    {
        "name": "ios-wifi",
        "tag": "bars,connection,internet,wifi"
    },
    {
        "name": "ios-wifi-outline",
        "tag": "bars,connection,internet,wifi"
    },
    {
        "name": "md-wifi",
        "tag": "bars,connection,internet,wifi"
    },
    {
        "name": "logo-windows",
        "tag": "pc,logo,windows"
    },
    {
        "name": "ios-wine",
        "tag": "wine"
    },
    {
        "name": "ios-wine-outline",
        "tag": "wine"
    },
    {
        "name": "md-wine",
        "tag": "wine"
    },
    {
        "name": "ios-woman",
        "tag": "dudette,female,girl,lady,woman"
    },
    {
        "name": "ios-woman-outline",
        "tag": "dudette,female,girl,lady,woman"
    },
    {
        "name": "md-woman",
        "tag": "dudette,female,girl,lady,woman"
    },
    {
        "name": "logo-wordpress",
        "tag": "blogging,logo,wordpress"
    },
    {
        "name": "logo-xbox",
        "tag": "fun,games,logo,xbox"
    },
    {
        "name": "logo-yahoo",
        "tag": "logo,yahoo"
    },
    {
        "name": "logo-yen",
        "tag": "logo,yen"
    },
    {
        "name": "logo-youtube",
        "tag": "share,logo,video,view,watch,youtube"
    },
    {
        "name": "ios-loading",
        "tag": "load,spin,loading"
    }
]